<template>
  <section class="elect-legislator" v-if="data">
    <ElectLabel :year="year" :category="category" :color="themeColor" />
    <SegmentChart
      :caption="segmentChartCaption"
      :winner-color="themeColor"
      :colors="segmentChartColors"
      :values="segmentChartValues"
      :labels="segmentChartLabels"
      :roles="segmentChartRoles"/>
    <SeatsChart
      :year="Number(year)"
      :colors="seatsChartColors"
      :values="seatsChartValues"
      :votes="seatsChartVotes"
      :proportions="seatsChartProportions"
      :groups="seatsChartGroups"
      :roles="seatsChartRoles"/>
    <DonutChart
      v-if="data.notVoting.all"
      :theme-color="themeColor"
      :display="donutChartDisplay"
      :comparison="donutChartComparison"
      :values="donutChartValues"
      :colors="['#c6c6c6', themeColor]"
      :labels="['投票數', '未投票']"/>
    <NotVotingTable
      v-if="data.notVoting.counties && data.notVoting.counties.length"
      :color="themeColor"
      :data="notVotingTableData"/>
  </section>
</template>

<script>
import { PARTY_COLORS, PARTY_LIGHTEN_COLORS, PARTY_NAMES } from '@/constant'
import ElectLabel from '@/components/ElectLabel'
import SegmentChart from '@/components/SegmentChart'
import SeatsChart from '@/components/SeatsChart'
import DonutChart from '@/components/DonutChart'
import NotVotingTable from '@/components/NotVotingTable'

export default {
  name: 'ElectLegislator',
  components: {
    ElectLabel,
    SegmentChart,
    SeatsChart,
    DonutChart,
    NotVotingTable
  },
  props: {
    data: { type: Object, default: () => {} }
  },
  data () {
    return {
      category: '立法委員',
      themeColor: '#ffb29b'
    }
  },
  computed: {
    year () {
      return this.data.year.toString()
    },
    segmentChartCaption () {
      return `總席次: ${this.data.totalSeats} 席`
    },
    segmentChartColors () {
      return this.data.result.map(({ party }) => PARTY_COLORS[party])
    },
    segmentChartValues () {
      return this.data.result.map(({ proportion }) => proportion)
    },
    segmentChartLabels () {
      return this.data.result.map(({ seats }) => `${seats} 席`)
    },
    segmentChartRoles () {
      return this.data.result.map(({ party }) => [ PARTY_NAMES[party] ])
    },
    seatsChartDetail () {
      const obj = this.data.detail.reduce((obj, row) => {
        let { party, isAtLarge } = row
        if (!obj[party]) {
          obj[party] = []
        }
        obj[party][!isAtLarge ? 0 : 1] = { ...row }
        return obj
      }, {})
      return Object
        .entries(obj)
        .map(([key, value]) => value)
    },
    seatsChartValues () {
      return this.seatsChartDetail.map(group => group.map(({ seats }) => seats))
    },
    seatsChartColors () {
      return this.data.result.map(({ party }) => [ PARTY_COLORS[party], PARTY_LIGHTEN_COLORS[party] ])
    },
    seatsChartGroups () {
      return this.data.result.map(({ party }) => PARTY_NAMES[party])
    },
    seatsChartRoles () {
      return this.data.result.map(({ party }) => {
        const partyName = PARTY_NAMES[party]
        return [ `${partyName}分區`, `${partyName}不分區` ]
      })
    },
    seatsChartVotes () {
      return this.seatsChartDetail.map(group => group.map(({ votes }) => votes))
    },
    seatsChartProportions () {
      return this.seatsChartDetail.map(group => group.map(({ proportion }) => proportion))
    },
    donutChartDisplay () {
      return this.data.notVoting.all.notVotes
    },
    donutChartComparison () {
      return this.data.notVoting.all.offsetProportion
    },
    donutChartValues () {
      const { proportion, notProportion } = this.data.notVoting.all
      return [ proportion, notProportion ]
    },
    notVotingTableData () {
      return this.data.notVoting.counties.map(({ county, notVotes, notProportion }) => ({ county, notVotes, notProportion }))
    }
  }
}
</script>

<style lang="scss">
.elect-legislator {

  .seats-chart {
    margin-top: 20px;
  }
}
</style>
